<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page6">To Vin Richards, Keith McCarty, Mr. Shelton, Mr. Sudduth, and all my musical friends and mentors.</a></p><a id="page6">
<p class="dedi1">Most especially, to Marcia McNiel Diehl and P. N. Elrod, for being chandeliers in a world of bug zappers.</p>
<p class="dedi1">Special heartfelt thanks to my editor, Jennifer Sawyer Fisher. She knows why.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?21384bac